import React from "react";

import { ConstrainedElement } from "../constrainedElement";
import { ConstraintTypeForm } from "@common/constraintTypeForm";
import { Props } from "./types";
import styles from "./styles.scss";

function StartEndForm({
  constraint,
  origin,
  target,
  deltaOffset,
  setDeltaOffset,
  setConstraint,
}: Props) {
  return (
    <div className={styles.form}>
      <ConstrainedElement
        element={{
          ...origin,
          isList: constraint.originEntityType === "ACTIVITY",
          isTask: constraint.originEntityType === "TASK",
          isMilestone: constraint.originEntityType === "MILESTONE",
        }}
        dateType={"START"}
      />
      <ConstraintTypeForm
        constraint={constraint}
        deltaOffset={deltaOffset}
        editConstraint={(nextConstraint, nextDeltaOffset) => {
          setConstraint(nextConstraint);
          setDeltaOffset(nextDeltaOffset);
        }}
      />
      <ConstrainedElement
        element={{
          ...target,
          isList: constraint.targetEntityType === "ACTIVITY",
          isTask: constraint.targetEntityType === "TASK",
          isMilestone: constraint.targetEntityType === "MILESTONE",
        }}
        dateType={"END"}
      />
    </div>
  );
}

export { StartEndForm };
